import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Box, Divider, Paper, Typography, makeStyles } from '@material-ui/core';
import CircularProgress from 'components/shared/CircularProgress';
import ComplaintInfo from './ComplaintInfo';
import ComplaintTimeline from './ComplaintTimeline';
import HostResponseForm from './HostResponseForm';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const HostComplaintDetail = ({ complaint, isLoading, isUpdating, conflict, onRespond }) => {
  const classes = useStyles();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!complaint) {
    return null;
  }

  const canRespond = complaint.status === 'pending_host';

  return (
    <>
      <ComplaintInfo complaint={complaint} view="host" />

      {canRespond && (
        <Paper className={classes.paper}>
          <Typography variant="subtitle1" gutterBottom>
            <FormattedMessage id="complaints.host.respond" defaultMessage="Respond to complaint" />
          </Typography>
          <Divider />
          <Box mt={2}>
            <HostResponseForm
              onSubmit={onRespond}
              isUpdating={isUpdating}
              conflict={conflict}
              maxCompensation={complaint.booking?.total_price}
            />
          </Box>
        </Paper>
      )}

      <Paper className={classes.paper}>
        <Typography variant="subtitle1" gutterBottom>
          <FormattedMessage id="complaints.timeline" defaultMessage="Response timeline" />
        </Typography>
        <Divider />
        <ComplaintTimeline responses={complaint.responses} />
      </Paper>
    </>
  );
};

HostComplaintDetail.propTypes = {
  complaint: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
    responses: PropTypes.array,
    booking: PropTypes.shape({
      total_price: PropTypes.number,
    }),
  }),
  isLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  conflict: PropTypes.bool,
  onRespond: PropTypes.func,
};

export default HostComplaintDetail;
